import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class JobDictionaryApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'job-dictionary'
  }

}